import { getCmsHomeBannerListAction } from "../../../Actions/LogicActions/CmsHomePageBanner/GetCmsHomeBannerListAction";
import { getCmsAboutMonthlyPassAction } from "../../../Actions/LogicActions/CMSOffers/GetCmsAboutMonthlyPassAction";
import { getCmsAboutTravelPassAction } from "../../../Actions/LogicActions/CMSOffers/GetCmsAboutTravelPassAction";
import { getCmsMonthlyPassOfferAction } from "../../../Actions/LogicActions/CMSOffers/GetCmsMonthlyPassOfferAction";
import { getCmsOffersAction } from "../../../Actions/LogicActions/CMSOffers/GetCMSOffersAction";
import { getCmsSpecialFareOfferAction } from "../../../Actions/LogicActions/CMSOffers/GetCmsSpecialFareOfferAction";
import { getCmsSpecialFareOfferDetailAction } from "../../../Actions/LogicActions/CMSOffers/GetCmsSpecialFareOfferDetailAction";
import { getCmsTravelPassOfferAction } from "../../../Actions/LogicActions/CMSOffers/GetCmsTravelPassOfferAction";
import { offersBookNowAction } from "../../../Actions/UIActions/CMSOffers/OffersBookNowAction";
import { offersDicoverClickAction } from "../../../Actions/UIActions/CMSOffers/OffersDiscoverClickAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import { loadAtomFromStorage, updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ICmsMonthlyPassOffer, ICmsTravelPassOffer, IOfferDiscoverParams } from "../../../Orchestrator/Types/Interface/ICMSOffers";
import { OffersContext } from "../Context/OffersContext";
import { passengerTypeAction } from "../../../Actions/Index";
import { getTicketOptionsAction } from "../../../Actions/LogicActions/Search/GetTicketOptionsAction";
import { getBookedPassesAction } from "../../../Actions/LogicActions/CMSOffers/GetBookedPassesAction";
import { enumOfferPassType } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { IOfferPassType } from "../../../Orchestrator/Types/Types/OffersResponse";
import { IPassBooking } from "../../../Orchestrator/Types/Types/BookingTypes";
import { prepareBookingSummaryAction } from "../../../Actions/LogicActions/Checkout/Summary/PrepareBookingSummaryAction";
import { IBookingResponse } from "../../../Orchestrator/Types/Index";
import { generatePassBookingPersistAtomKey, PASS_BOOKING_WHITELIST_ATOMS } from "../../../Orchestrator/Recoils/OfferAtoms";

class OffersInitStep extends StepFlow {
  get stepName() {
    return "OffersInit_Step";
  }

  async onEventSetup(): Promise<void> {

    this.registerEventSubscription(
      _eventBus.on<void, void>({
        eventName: evtTree.CMSOffers.Init,
        handler: async ({ }) => {
          getTicketOptionsAction.execute()
          await passengerTypeAction.execute();
          updateRecoilState("passengerTypesStateAtom", passengerTypeAction.result);

          getCmsHomeBannerListAction.setParams({
            queryParams: {
              "filters[offer_banner][$eq]": true
            }
          })
          getCmsHomeBannerListAction.execute();
          getCmsMonthlyPassOfferAction.execute();
          getCmsTravelPassOfferAction.execute();
          getCmsSpecialFareOfferAction.execute();
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<{ data: IOfferDiscoverParams }, void>({
        eventName: evtTree.CMSOffers.OfferPass.ContinueAfterLogin,
        handler: async ({ data }) => {
          setTimeout(async () => {
            for (const atomKey of PASS_BOOKING_WHITELIST_ATOMS) {
              const state = loadAtomFromStorage(generatePassBookingPersistAtomKey(atomKey));
              updateRecoilState(atomKey, state);
            }

            const bookingResponse = loadAtomFromStorage(generatePassBookingPersistAtomKey("bookingResponseAtom")) as IBookingResponse | null;
            if (bookingResponse && bookingResponse?.booking) {
              prepareBookingSummaryAction.setParams({ ...bookingResponse.booking })
              await prepareBookingSummaryAction.execute()
            }

            getTicketOptionsAction.execute()
            await passengerTypeAction.execute();
            updateRecoilState("passengerTypesStateAtom", passengerTypeAction.result);

            const context = this.getCtx<any>("offersContext");
            if (context) {
              context.routeTo = context.offerDetailSteps;
              this.next();
            }
          })
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<void, void>({
        eventName: evtTree.CMSOffers.BookedPass.Get,
        handler: async ({ }) => {
          getBookedPassesAction.execute();
        }
      })
    );

    this.registerEventSubscription(
      _eventBus.on<void, void>({
        eventName: evtTree.CMSOffers.List.Get,
        handler: async ({ }) => {
          await getCmsOffersAction.execute();
        },
      })
    );
 
    this.registerEventSubscription(
      _eventBus.on<void, void>({
        eventName: evtTree.CMSOffers.Discover.Click,
        handler: async (data) => {
          offersDicoverClickAction.setParams(data.data!);
          await offersDicoverClickAction.execute();
        },
      })
    );
    this.registerEventSubscription(
      _eventBus.on<void, void>({
        eventName: evtTree.CMSOffers.BookNow.Click,
        handler: async ({ data }) => {
          if (data) {
            offersBookNowAction.setParams(data!);
            offersBookNowAction.execute();
          }
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<{
        type: IOfferPassType,
        offerPass: ICmsMonthlyPassOffer | ICmsTravelPassOffer
      }, void>({
        eventName: evtTree.CMSOffers.OfferPass.Click,
        handler: async ({ data }) => {
          const { type, offerPass } = data!;

          await Promise.all([
            getTicketOptionsAction.execute(),
            passengerTypeAction.execute()
          ]);

          updateRecoilState("passengerTypesStateAtom", passengerTypeAction.result);

          updateRecoilState<IOfferPassType>("offerPassTypeAtom", type);
          updateRecoilState<ICmsMonthlyPassOffer | ICmsTravelPassOffer | null>("selectedCmsPassOfferAtom", offerPass);
          updateRecoilState("offersPageViewAtom", "offerDetail");
          if (type === enumOfferPassType.monthlyPass) {
            getCmsAboutMonthlyPassAction.execute();
          } else if (type === enumOfferPassType.travelPass) {
            getCmsAboutTravelPassAction.execute();
          }
          const context = this.getCtx<any>("offersContext");
          if (context) {
            context.routeTo = context.offerDetailSteps
            this.next();
          }
        },
      })
    )

    this.registerEventSubscription(
      _eventBus.on<{ passBooking: IPassBooking }, void>({
        eventName: evtTree.CMSOffers.BookedPass.Click,
        handler: async ({ data }) => {
          const { passBooking } = data!;
          if (passBooking) {
            const context = this.getCtx<OffersContext>("offersContext");
            if (context) {
              updateRecoilState<IPassBooking | null>("selectedPassBookingAtom", passBooking);
              updateRecoilState("offersPageViewAtom", "bookedPassDetail");
              context.routeTo = ["BookedPassDetail_step"];
              this.next();
            }
          }
        },
      })
    )

    this.registerEventSubscription(
      _eventBus.on<void, void>({
        eventName: evtTree.CMSOffers.FlowClose,
        handler: async () => {
          updateRecoilState("selectedPassBookingAtom", null);

          _eventBus.emit({
            eventName: "FLOW_CLOSE",
            data: "OffersFlow",
          });
        }
      })
    )
  }

  async onExecute(): Promise<void> {
    console.log("Offers Init Step Execute...");

    const context = this.getCtx<any>("offersContext");
    if (!context) {
      const offerContext = new OffersContext();
      offerContext.offerDetailSteps = ["OfferDetail_step", "VoucherFlow", "PaymentInit_Step", "PassengerDetailsFlow"];
      this.setCtx("offersContext", offerContext);
    }
  }
}

export const OffersInitStepDeclaration = new StepDefinition({
  stepName: "OffersInit_Step",
  stepClass: OffersInitStep,
});
